/**
 * The main React rendering.
 *
 *     - index.js
 *       |--- App
 *          |------- Layout
 */

import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

//import registerServiceWorker from "./registerServiceWorker";
//import Log from "./log";

//SRL.logger = new Log(Log.WARNING);

const rootElement = document.getElementById("root");

ReactDOM.render(<App />, rootElement);

//registerServiceWorker();
